import type { WeekCalendarProps } from "../types";
import { useWeekCalendarSetup } from "../hooks/use-week-calendar-setup";
import { MobileCalendarView } from "./mobile/MobileCalendarView";
import { DesktopCalendarView } from "./DesktopCalendarView";

export function WeekCalendar(props: WeekCalendarProps) {
  const { mobileProps, desktopProps } = useWeekCalendarSetup(props);

  return (
    <div className="flex flex-col gap-3 h-full">
      <MobileCalendarView {...mobileProps} />
      <DesktopCalendarView {...desktopProps} googleCalendarUi={props.googleCalendarUi} />
    </div>
  );
}
